<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Gestione Percorsi Allegati Moduli</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="addAllegatoModulo">
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="saveAllegatiModuli">
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.push({ name: 'Dashboard' })"
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>
      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>
      <v-data-table
        :items="tabella.filter((e) => e.validita == 1)"
        :headers="headers"
      >
        <template v-slot:[`item.modifica`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                class="ma-1"
                @click="editAllegatoModulo(item)"
              >
                <v-icon color="#1a80b6"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modifica</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.elimina`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                @click="deleteAllegatoModulo(item)"
              >
                <v-icon class="error--text">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="showDialog" width="50%">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            {{ toolbarTitle }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="saveAllegatoModulo" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="showDialog = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                outlined
                dense
                label="Modulo"
                :items="moduli"
                item-text="des_modulo"
                item-value="id_modulo"
                return-object
                v-model="tempModulo"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                label="Percorso"
                v-model="tempPercorso"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "AllegatiModuli",
  components: {
    SnackbarQV,
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      nextTempId: 1,
      toolbarTitle: "",
      modify: false,
      tempModulo: {},
      editingItem: {},
      tempPercorso: "",
      moduli: [],
      tabella: [],
      headers: [
        {
          text: "",
          value: "modifica",
        },
        {
          text: "Codice",
          value: "cod_modulo",
        },
        {
          text: "Modulo",
          value: "des_modulo",
        },
        {
          text: "Percorso",
          value: "percorso",
        },
        {
          text: "",
          value: "elimina",
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    await this.getModuli();
    await this.getAllegatiModuli();
    this.loading = false;
  },
  methods: {
    async getModuli() {
      const request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getmoduliazienda",
          id_azienda: localStorage.getItem("id_azienda"),
          token: localStorage.user_token,
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        this.moduli = Array.from(res.data.result.moduli);
      });
    },
    async getAllegatiModuli() {
      const request = {
        controller: "Allegati",
        method: "POST",
        richiesta: {
          action: "getallegatimodulo",
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.data.isCompletedSuccessfully) {
          this.tabella = JSON.parse(res.data.result);
          this.tabella.forEach((e) => {
            e.tempId = -1;
          });
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },
    addAllegatoModulo() {
      this.modify = false;
      this.toolbarTitle = "Nuovo Allegato Modulo";
      this.showDialog = true;
    },
    async saveAllegatiModuli() {
      this.loading = true;
      const request = {
        controller: "Allegati",
        method: "PUT",
        richiesta: {
          action: "setallegatimodulo",
          allegati_moduli: this.tabella,
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.data.isCompletedSuccessfully) {
          this.$refs.SnackbarQV.print("success", "Allegati Moduli Salvati");
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
      await this.getAllegatiModuli();
      this.loading = false;
    },
    editAllegatoModulo(item) {
      this.modify = true;
      this.toolbarTitle = "Modifica Allegato Modulo";
      this.editingItem = item;
      this.tempModulo.id_modulo = item.id_modulo;
      this.tempPercorso = item.percorso;
      this.showDialog = true;
    },
    deleteAllegatoModulo(item) {
      if (item.id_allegati_modulo == -1) {
        for (let i = 0; i < this.tabella.length; i++) {
          if (
            this.tabella[i].id_allegati_modulo == -1 &&
            this.tabella[i].tempId == item.tempId
          ) {
            this.tabella.splice(i, 1);
            break;
          }
        }
      } else {
        for (let i = 0; i < this.tabella.length; i++) {
          if (this.tabella[i].id_allegati_modulo == item.id_allegati_modulo) {
            this.tabella[i].validita = 0;
            break;
          }
        }
      }
    },
    saveAllegatoModulo() {
      if (this.modify) {
          this.editingItem.id_modulo = this.tempModulo.id_modulo;
          this.editingItem.percorso = this.tempPercorso;
      } else {
        this.tabella.push({
          id_allegati_modulo: -1,
          id_modulo: this.tempModulo.id_modulo,
          percorso: this.tempPercorso,
          cod_modulo: this.tempModulo.cod_modulo,
          des_modulo: this.tempModulo.des_modulo,
          validita: 1,
          tempId: this.nextTempId,
        });
        this.nextTempId++;
      }
      this.tempModulo = {};
      this.tempPercorso = "";
      this.showDialog = false;
    },
  },
};
</script>